import fetcher from '../utils/api';

const knowledgePageService = {
  createKnowledgePage: async (data, location) => fetcher(`knowledge_pages/?location=${location}`, 'POST', true, data),
  appendToKnowledgePage: async ({ id, data }) => fetcher(`knowledge_pages/${id}/append/`, 'PATCH', true, data),
  duplicateKnowledgePage: async ({ pageToBeDuplicatedId, keepScribes, orgId }) => {
    const endpoint = `knowledge_pages/${pageToBeDuplicatedId}/duplicate/${!keepScribes ? '?replace_scribes=1' : ''}`;

    return fetcher(endpoint, 'POST', true, { organization_id: orgId });
  },
  updateKnowledgePage: async (id, { editor_js_data, data_hash }) => {
    return fetcher(`knowledge_pages/${id}/`, 'PATCH', true, {
      editor_js_data,
      data_hash
    });
  },
  changeUserPermission: async (id, userId, permissionLevel) =>
    fetcher(`permissions/user_object_permission/document_metadata/${id}/`, 'PUT', true, {
      user: userId,
      permission_level: permissionLevel
    }),
  changeCandidatePermission: async (id, email, permissionLevel) =>
    fetcher(`permissions/candidate_scribe_document_permission/${id}/`, 'PUT', true, {
      email,
      permission_level: permissionLevel
    }),
  getUsersWithPermission: async (id) => fetcher(`permissions/user_object_permission/document_metadata/${id}/`, 'GET', true),
  getCandidatesWithPermission: async (id) => fetcher(`permissions/candidate_scribe_document_permission/${id}/`, 'GET', true),
  updateKnowledgePageMetadata: async (
    id,
    {
      name = undefined,
      icon = undefined,
      icon_color = undefined,
      is_colorful_header_enabled = undefined,
      colorful_header = undefined,
      allow_feedback = undefined,
      app_tag_id = undefined,
      is_auto_add_app_tags_enabled = undefined,
      app_tag_by_url = undefined
    }
  ) =>
    fetcher(`knowledge_pages/${id}/document_metadata/`, 'PATCH', true, {
      ...(name != null ? { name } : {}),
      icon,
      icon_color,
      is_colorful_header_enabled,
      colorful_header,
      allow_feedback,
      app_tag_id,
      is_auto_add_app_tags_enabled,
      app_tag_by_url
    }),
  updateKnowledgePagePermission: async (id, data) => fetcher(`knowledge_pages/${id}/global_permission/`, 'PATCH', true, data),
  fetchKnowledgePage: async (pid, isAuthenticated = false, userAgent = null, token = null) => {
    const additionalParams = [];

    if (userAgent !== undefined && userAgent !== null) {
      additionalParams.push(`user_agent=${encodeURIComponent(userAgent)}`);
    }
    return fetcher(
      `knowledge_pages/${pid}/${additionalParams.length > 0 ? '?' : ''}${additionalParams.join('&')}`,
      'GET',
      isAuthenticated,
      undefined,
      undefined,
      token
    );
  },
  uploadMedia: async ({ pid, mediaItem }) => {
    return fetcher(`knowledge_pages/${pid}/document_media/`, 'POST', true, { id: pid, media_item: mediaItem });
  },
  getMediaUrlById: async ({ pid, mediaId }) => {
    return fetcher(`knowledge_pages/${pid}/document_media/?id=${mediaId}`, 'GET', true);
  }
};

export default knowledgePageService;
